







































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxStateStoring,
  DxRequiredRule,
} from 'devextreme-vue/data-grid';
import { ArticleStatusEnum } from '../enums/ArticleStatusEnum';

@Component({
  components: {
    cCard,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxRequiredRule,
    DxStateStoring,
  },
})
export default class RawMaterialsCompositionCard extends Vue {
  @Prop({required: true})
  public value!: IArticleUsedMaterial[];

  @Prop({required: true})
  public rawmaterials?: any[];

  @Prop({required: false, default: true})
  public editable!: boolean;

  private editableValue: IArticleUsedMaterial[] = [];

  private mounted() {
    this.editableValue = Object.assign([], this.value);
  }

  private add() {
    const table: any = this.$refs.articleResourceTable;
    table.instance.addRow();
  }

  private async onRowUpdated(e: any) {
    this.$emit('input', this.editableValue);
  }

  get columns() {
    const self = this;
    if(this.rawmaterials){
        this.rawmaterials.forEach((rawmaterial) => {
        rawmaterial.visible = rawmaterial.status == ArticleStatusEnum.Active;
      });
    }
    return [
      {
        dataField: 'rawMaterialRef',
        caption: this.$t('objects.articles.RawMaterial'),
        lookup: {
          dataSource: this.rawmaterials,
          displayExpr: 'name',
          valueExpr: 'id',
        },
        editorOptions: {
          searchEnabled: 'true',
          showClearButton: 'true',
        },
        validationRules: [{
          type: 'required',
          message: 'Dit veld is verplicht!',
        }],
      },
      {
        caption: this.$t('objects.articles.UnitPrice'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value || !self.rawmaterials || !value.rawMaterialRef || value.rawMaterialRef === '') {
            return 0;
          }

          const material = self.rawmaterials.find((o: any) => o.id === value.rawMaterialRef);

          return material?.defaultPrice?.purchasePriceDefaultMeasuringUnit ?? 0;
        },
      },
      {
        caption: this.$t('objects.articles.MeasuringUnit'),
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value || !self.rawmaterials || !value.rawMaterialRef || value.rawMaterialRef === '') {
            return '';
          }

          const material = self.rawmaterials.find((o: any) => o.id === value.rawMaterialRef);
          return material ? material.measuringUnit : '';
        },
      },
      {
        caption: 'Hoeveelheid',
        columns: [
           {
            dataField: 'quantityWithoutLosses',
            caption: 'Aantal',
            dataType: 'number',
            alignment: 'left',
            validationRules: [{
              type: 'required',
              message: 'Dit veld is verplicht!',
            }],
          },
          {
            dataField: 'lossPercentage',
            caption: 'Verlies %',
            dataType: 'number',
            alignment: 'left',
            validationRules: [{
              type: 'required',
              message: 'Dit veld is verplicht!',
            }],
          },
          {
            dataField: 'amount',
            caption: 'Totaal',
            dataType: 'number',
            alignment: 'left',
            allowEditing: false,
            calculateCellValue(value: any) {


              return Math.round(((value.quantityWithoutLosses ?? 0) * (1 + (value.lossPercentage ?? 0) / 100 )) * 10000) /  10000;
            },
          },
        ],
      },
      {
        caption: this.$t('objects.articles.Total'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value || !self.rawmaterials || !value.rawMaterialRef || value.rawMaterialRef === '') {
            return 0;
          }

          const material = self.rawmaterials.find((o: any) => o.id === value.rawMaterialRef);
          const amount = (value.quantityWithoutLosses * (1 + value.lossPercentage / 100 ));
          return material ? amount * material.defaultPrice.purchasePriceDefaultMeasuringUnit : 0;
        },
      },
    ];
  }

  get total() {
    let val = 0;
    const self = this;

    if (!this.value || !this.value || !this.rawmaterials) {
      return val;
    }

    this.value.forEach((material: any) => {
      if (material.amount && material.rawMaterialRef) {
        const rawmaterial = this.rawmaterials ?
        this.rawmaterials.find((o: any) => o.id === material.rawMaterialRef) : null;
        if (rawmaterial) {
          val += material.amount * rawmaterial.defaultPrice.purchasePriceDefaultMeasuringUnit;
        }
      }
    });

    return val;
  }
}
